module.exports = __webpack_public_path__ + "img/shape-6.81c7b256.png";